import type { ReactNode } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  /** Что продолжат видеть ученики: «курса» / «статьи». */
  subject: string
  /** Строка под описанием (у курса — о несохранённом экране). */
  note?: ReactNode
}

/** Подтверждение `DELETE …/draft` — общее для курса и статьи: черновик удаляется целиком,
 *  живая версия не меняется. */
export const DiscardDraftAlert = ({ open, onOpenChange, onConfirm, subject, note }: Props) => {
  const m = useMessages(messages)
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.discardTitle}</AlertDialogTitle>
          <AlertDialogDescription>{m.discardDescription(subject)}</AlertDialogDescription>
        </AlertDialogHeader>
        {note ?? null}
        <AlertDialogFooter>
          <AlertDialogCancel>{m.back}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {m.discardConfirm}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
